import { Check } from '@chain-zen/ui'

import type { TELDAppSource } from '../../../types/tracking'
import { ELDIcon } from '../eld-icon'
import { TrackingSourceRow } from '../tracking-source-row'
import { TrackingTimeDisplay } from '../tracking-time-display'

interface IELDAppInfoProps {
  trackingSourceData: TELDAppSource
}

/**
 * Displays the details for ELD app
 */
export const ELDAppInfo = (props: IELDAppInfoProps) => {
  const { trackingSourceData } = props
  const lastLocation =
    trackingSourceData?.locations && trackingSourceData.locations.length > 0
      ? trackingSourceData.locations[trackingSourceData.locations.length - 1]
      : null

  return (
    <TrackingSourceRow className="px-2">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1 flex-wrap">
          <Check className="h-3 w-3 shrink-0 self-center text-green-500 dark:text-green-400" />
          <ELDIcon provider={trackingSourceData?.metadata?.provider || 'ELD App'} size={3} />
          <span className="text-sm font-medium text-foreground">
            {trackingSourceData?.metadata?.provider || 'ELD App'}
          </span>
          {!!lastLocation && (
            <TrackingTimeDisplay
              filterReason={trackingSourceData.filterReason}
              lastLocationCity={lastLocation.city}
              lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
              lastLocationStateCode={lastLocation.stateCode}
              lastLocationTimestamp={lastLocation.timestamp}
              wrapper="div"
              className="text-xs text-muted-foreground"
            />
          )}
        </div>

        <div className="flex items-center gap-1 text-xs text-muted-foreground flex-wrap">
          <span>Device ID: {trackingSourceData?.metadata?.deviceID}</span>
        </div>
      </div>
    </TrackingSourceRow>
  )
}
